import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'

import Checkbox from 'material-ui/Checkbox'
import StatusSelect from './StatusSelect'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead, currentDate } from 'selectors/common'
import { lastPropertyLease } from 'selectors/leases'
import { objectAttachments } from 'selectors/attachments'
import { propertiesLLEx } from 'selectors/properties'
import { getMonth, getTimezoneDate } from 'utils/date'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , events: propertiesLLEx(state)[props.propertyID]
  	  , lastPropertyLease: lastPropertyLease(state, props)
  	  , currentDate: currentDate(state)
	  , attachments: objectAttachments(state, props)
	})
)

function checkStatuses (props) {
    let statuses = ''
    if (props.events && props.events.status && props.events.status.forRent!='For Rent' && props.events.status.occupied!='Occupied' && !props.property.dateTill && Moment(props.lastPropertyLease.dateTill)<=Moment(props.currentDate)) statuses+="\nNot in Service"
    if (props.events && props.events.status && props.events.status.forRent=='For Rent' && !props.property.dateTill) statuses+="\nFor rent"
    if (props.events && props.events.status && props.events.status.contracted=='Contracted' && !props.property.dateTill) statuses+= "\nContracted"
    if (props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill  &&  props.events.status.notPaying!='Not Paying') statuses+= "\nOccupied \nPaid"
    if (props.events && props.events.status && props.events.status.occupied=='Occupied' && !props.property.dateTill  &&  props.events.status.notPaying=='Not Paying') statuses+= "\nOccupied \nUnpaid"
    if (props.property && props.property.dateTill) statuses+= "Retired"
    return statuses
}

export class PropertyAvatar extends Component{
	render(){
		let { props } = this
		let imgUrl //= "/static/img/avatar.jpg"
		R.forEach(attach => {
			if (attach.contentType.includes('image')) {
				if (!imgUrl) {imgUrl = attach.url}
				return false
			}
		})(props.attachments)
		return(
            <div
				title={checkStatuses(props)}
				style={{
					position:"relative"
				  , fontSize: "0"
				  , width: "150px"
				  , height: "150px"
				  , overflow: 'hidden'
				  , position: 'relative'
					, float: "left"
				}}
			>
                <img
					style={{
						display: 'block'
					  , margin: "auto"
					  , position: "absolute"
					  , top: "-100%"
					  , right: "-100%"
					  , bottom: "-100%"
					  , left: "-100%"
					  , minWidth: "100%"
					  , minHeight: "100%"
					}}
					src={imgUrl? imgUrl : "/landlord/static/img/no-property-photo.png"} alt="no-photo" width="150" />
                <div style={{position:"absolute", left:"0", bottom:"5px", zIndex: "2"}}>
                    <StatusSelect propertyID={props.propertyID}/>
                </div>
				<div
					className="gradient-overlay"
					style={{
						background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 40%)"
					  , width: "100%"
					  , height: "100%"
					  , position: 'absolute'
					  , zIndex: "1"
					}}
				>
				</div>
            </div>
		)
	}
}

export default connect(select, dataActions)(PropertyAvatar)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/propertyForm/PropertyAvatar.js